import { render, staticRenderFns } from "./RealNameSuccess.vue?vue&type=template&id=43d90b78&scoped=true&"
import script from "./RealNameSuccess.vue?vue&type=script&lang=js&"
export * from "./RealNameSuccess.vue?vue&type=script&lang=js&"
import style0 from "./RealNameSuccess.vue?vue&type=style&index=0&id=43d90b78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d90b78",
  null
  
)

export default component.exports